import { thunk, action } from 'easy-peasy'
import { sdocUser } from '../../../api/index'

export const sdocUserModel = {
	userSDOC: null,
	userMESDOC: null,
	userLoginExpireDate: null,

	// Synchronous action (modifies state directly)
	setUserSDOC: action((state, userSDOC) => {
		state.userSDOC = userSDOC
		state.userLoginExpireDate = userSDOC ? new Date().getTime() + 3600000 * 8 : null
	}),

	setUserMeSDOC: action((state, userMESDOC) => {
		state.userMESDOC = userMESDOC
	}),

	// Thunk for async login
	signInUser: thunk(async (actions, payload) => {
		const res = await sdocUser.signInSDOCUser(payload)
		if (res && res.status === 200) {
			const response = res.data
			actions.setUserSDOC(response)
			actions.fetchCompanyName(response.poa) // Call the new thunk
			actions.getUserProfile()
			return response
		}
	}),

	// Thunk to handle async company name fetching
	fetchCompanyName: thunk(async (actions, poa) => {
		if (!poa) return

		const res = await sdocUser.getCompanyName(poa)
		if (res && res.status === 200) {
            actions.updateUserCompanyName(res.data)
        }else{
			actions.updateUserCompanyName(null)
		}
	}),

	// Action to update the state with the fetched company name
	updateUserCompanyName: action((state, data) => {
		if (state.userSDOC) {
			state.userSDOC.companyName = data?.operatorName || state.userSDOC.poa
		}
	}),

	signOutUser: thunk(actions => {
		actions.setUserSDOC(null)
		actions.setUserMeSDOC(null)
	}),

	getUserProfile: thunk(async (actions, _, helpers) => {
	const state = helpers.getState();
	const poa = state.userSDOC?.poa;

	if (!poa) return; // Optional: handle missing poa gracefully

	const res = await sdocUser.getMyProfile(poa);
	if (res && res.status === 200) {
		const data = res?.data?.user?.[0];
		actions.setUserMeSDOC(data);
	}
}),
}
